import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const LayoutPage = () => {
    return (
        <div className="otpBank-layout-page">
            <FullWrapper className="otpBank-layout-pageCase">
                <div className="otpBank-layout-pageWrapper">
                    <div className="otpBank-layout-pageTitle">Описание проекта</div>
                    <div className="otpBank-layout-pageInner">
                        <div className="otpBank-layout-pageLeft">
                            <div>
                                Клиент обратился в&nbsp;наше агентство с&nbsp;комплексной задачей
                                увеличить небрендовый трафик и&nbsp;видимость сайта
                                в&nbsp;приоритетных бизнес-направлениях, так как команда
                                &laquo;Вебпрактик&raquo; накопила большую экспертизу по&nbsp;SEO для
                                финтеха, работая с&nbsp;банками из&nbsp;топ-50.
                            </div>
                            <div>
                                Все банки стремятся обогнать конкурентов и&nbsp;получить первые
                                строчки в&nbsp;выдаче, трафик и&nbsp;клиентов. Расскажем
                                о&nbsp;поэтапной работе с&nbsp;ОТП Банком и&nbsp;покажем результаты,
                                а&nbsp;также дадим ряд рекомендаций по&nbsp;SEO-продвижению для
                                финтеха.
                            </div>
                            <div>
                                При продвижении сайтов финансовых организаций есть несколько
                                ключевых особенностей: широкая и&nbsp;разнообразная целевая
                                аудитория, большое количество продуктовых страниц и&nbsp;расширенное
                                семантическое ядро.
                            </div>
                        </div>
                        <div className="otpBank-layout-pageRight">
                            При продвижении сайтов финансовых организаций есть несколько ключевых
                            особенностей.
                        </div>
                    </div>
                </div>
            </FullWrapper>
            <div className="otpBank-layout-pageContainer">
                <img
                    src="/images/pic/otp-bank/banner.jpg"
                    alt="banner"
                    className="otpBank-layout-pageBanner"
                />
            </div>
        </div>
    );
};

export default LayoutPage;
